// Single selling-price rule for parts. Keep in sync with the inline copies in
// supabase/functions/{parts-cart,parts-checkout-quote,parts-paypal-create-order}.
//  1. staff sale price  2. staff override
//  3. MAP below cost -> cost + 20%
//  4. retail, raised to MAP if below it (MAP is a floor)
//  5. no retail -> MAP, else cost + 20%
export const MAP_BELOW_COST_MARKUP = 0.2;

const pos = (v: unknown): number | null => {
  if (v == null || v === "") return null;
  const n = typeof v === "number" ? v : parseFloat(String(v));
  return Number.isFinite(n) && n > 0 ? n : null;
};

export interface PriceInputs {
  sale?: unknown;
  override?: unknown;
  retail?: unknown;
  map?: unknown;
  cost?: unknown;
}

export function partsSellPrice(i: PriceInputs): number | null {
  const sale = pos(i.sale);
  if (sale) return sale;
  const ov = pos(i.override);
  if (ov) return ov;
  const map = pos(i.map);
  const cost = pos(i.cost);
  const retail = pos(i.retail);
  const costPlus = cost ? +(cost * (1 + MAP_BELOW_COST_MARKUP)).toFixed(2) : null;
  if (map && cost && map < cost) return costPlus;
  if (retail) return map && retail < map ? map : retail;
  return map ?? costPlus;
}

export function partsSellPriceRow(r: any): number | null {
  return partsSellPrice({
    sale: r.admin_sale_price,
    override: r.admin_price,
    retail: r.customer_retail_price,
    map: r.map_retail,
    cost: r.customer_cost,
  });
}

export function markupPct(price: unknown, cost: unknown): number | null {
  const p = pos(price), c = pos(cost);
  return p && c ? ((p - c) / c) * 100 : null;
}
